import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewEvent = () => {
  useEffect(() => {
    bridge.logAnalyticsEvent({
      name: 'VIEW_RECENTLY_VIEWED_GOODS',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'RECENTLY_VIEWED_GOODS',
      },
    });
  }, []);
};
